import { Component, OnInit, ViewChild } from '@angular/core';
import {  ZXingScannerComponent } from '@zxing/ngx-scanner';
import { throwError, fromEvent, of, Observable, Subscriber } from 'rxjs';
import {  map, tap, catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { CardApi, LoopBackAuth } from '../../../../assets/js/lb-sdk';

@Component({
    selector: 'app-scanner',
    templateUrl: './scanner.component.html'
  })
export class ScannerComponent implements OnInit {

@ViewChild('scanner', { read: false })
scanner: ZXingScannerComponent;

showCamera=false;
loadingCameras = true;
activating = false;
camerasFound;

debugText: string = 'start';

constructor(
    private cardApi: CardApi,
    private loopBackAuth: LoopBackAuth,
    private toastr: ToastrService
) {  }

ngOnInit() {}

setCamera(i) {
  if (this.camerasFound && i < this.camerasFound.length) {
    this.scanner.device = this.camerasFound[i]; 
  }
}
loadCamera() {
    this.showCamera = true;
    this.setCamera(1);
}

camerasFoundHandler($event) {
  console.log($event);
  this.camerasFound = $event;
  this.loadingCameras = false;
  // this.setCamera(1);
}

scanSuccessHandler($event: string) {
  var data = JSON.parse($event);

  this.showCamera = false;
  this.activating = true;

  var { ProdType, PlanType, CardReferenceNumber } = data;
  this.cardApi.count( {userId: this.getUser().id, status: 0, planType: PlanType, productType: ProdType }  )
    .pipe(map(result => result.count === 0 
      ? throwError('No tokens available')
      : this.cardApi.activate({
          "referenceNumber":CardReferenceNumber,
          "productType":ProdType,
          "planType":PlanType})
          /*
          .pipe(catchError( error => {
              console.log('catch error',error);
            this.toastr.error(error.message || error);
            return of(error)
          } ))
        */

          .subscribe(res => { 
            console.log('subscribe 2',res)
            this.toastr.success(`Card ${CardReferenceNumber} activated`  );  
            return res 
        }, error => {
                console.log('catch error',error);
                this.toastr.error(error.message || error);
            }  )
    )
    ,catchError( error => { 
        console.log('catch error 2',error);
        this.toastr.error(error.message || error);
        return of(error) 
    } )
    )
    .subscribe(result => {

      if (result instanceof Observable) {
        result.pipe(catchError(error => { this.toastr.error(error.message || error);
            return of(error)} ))
            .subscribe(value => console.log('result subscribe',value))
      } else if (result instanceof Subscriber) {
        // result.complete()
    }

      this.activating = false;
    }, error => { console.log('error',error); this.debugText = error },
    () => {
       this.scanner.device = null;
       this.showCamera = false;
    })

}

    getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

}